import { Breadcrumb, Button, Collapse, notification, Pagination, PaginationProps, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  ProMaterialCardComponent,
  i18n,
  StoreStateInterface,
  ProMaterialInterface,
  NoDataComponent,
  getScreenTagsByTypeAction,
  TagScreenStateInterface,
  FilterComponent,
  ProMaterialEsResponseInterface,
  ProMaterialService,
  YearDividerComponent,
  SelectTypeEnum,
  clearNoteAction,
  LicenceInterface,
  LicenceResponseInterfaceSingle,
  LicenceService,
  LicenceUserResponseInterfaceAll,
  LicenceUserService,
  NoteResponseInterfaceAll,
  NoteService,
} from '../../../../common';
import { HomeOutlined, CaretRightOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearProMaterialAction,
  clearProMaterialListAction,
  getAllProMaterialsAction,
  ProMaterialStateInterface,
} from '../../../../common/redux/proMaterials';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { AdminRoutes } from '../../_router/admin.routes';

const { Panel } = Collapse;
const { Text } = Typography;

function ProMaterialsPageComponent() {
  const dispatch = useDispatch();
  const userAuth = useSelector((state: StoreStateInterface) => state.auth);
  const proMaterials: ProMaterialStateInterface = useSelector((state: StoreStateInterface) => state.proMaterial);

  const tags: TagScreenStateInterface = useSelector((state: StoreStateInterface) => state.tagScreen);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filterValues, setFilterValues] = useState();
  const [exactMatch, setExactMatch] = useState<boolean>(true);

  const [esData, setEsData] = useState<ProMaterialEsResponseInterface>();

  const [keyword, setKeyword] = useState('');
  //const [allOpinions, setAllOpinions] = useState(true);

  const [esSearch, setEsSearch] = useState(true);
  
  const [licenceData, setLicenceData] = useState<LicenceInterface>();
  const [noteData, setNoteData] = useState<NoteResponseInterfaceAll>();

  useEffect(() => {
    clearNoteAction();
    NoteService.getAll(userAuth.user?.id, false).subscribe(
      (response: NoteResponseInterfaceAll) => {
        setNoteData(response); 
      },
      (error: Error) => {
        notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
      }
    );
  }, [userAuth?.user?.id]);

  useEffect(() => {
    LicenceUserService.getAll(undefined, `filter[user.id]=${userAuth.user?.id}`, undefined, `page[offset]=0&page[limit]=999999`).subscribe(
      (response: LicenceUserResponseInterfaceAll) => {
        if (response.data?.length && response.data[0]) {
          const licenceId = response?.data[0]?.relationships?.licence?.data?.id;
          if (licenceId) {
            LicenceService.getSingle(licenceId).subscribe(
              (response: LicenceResponseInterfaceSingle) => {
                setLicenceData(response.data);
              }
            );
          }
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  useEffect(() => {
    localStorage.removeItem('transferFilters');
    dispatch(clearProMaterialAction());
    dispatch(clearProMaterialListAction());
    dispatch(getScreenTagsByTypeAction('pro_material'));
    esSearchFunction(false, { from: 0, size: pageSize }, keyword)
    /* dispatch(
      getAllProMaterialsAction(
        undefined,
        undefined,
        'sort=-year',
        `page[offset]=${pageSize * (page - 1)}&page[limit]=${pageSize}`
      )
    );*/
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const esSearchFunction = (
    allOpinions: boolean,
    pageSorted: { from: number; size: number },
    keyword?: string,
    tagIds?: any
  ) => {
    ProMaterialService.elasticSearch(allOpinions, pageSorted, exactMatch, keyword, tagIds).subscribe(
      (response: ProMaterialEsResponseInterface) => {
        setEsData(response);
      },
      (error: Error) => {
        notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
      }
    );
  };

  const refetch = (allValues: any) => {
    //setEsSearch(true);
    setFilterValues(allValues);
    setPage(1);
    esSearchFunction(false, { from: 0, size: pageSize }, keyword, allValues);
  };

  const resetSearch = () => {
    setEsData(undefined);
    setKeyword('');
    //setAllOpinions(true);
    //setEsSearch(false);
    setFilterValues(undefined);
    setPage(1);
    esSearchFunction(false, { from: 0, size: pageSize })
    //dispatch(getAllProMaterialsAction(undefined, undefined, 'sort=-year', `page[offset]=0&page[limit]=${pageSize}`));
  };

  const sortedProMaterials = (proMaterials: ProMaterialInterface[]) => {
    const tagYearsObject = tags?.tagScreens?.find(x => x.selectType === SelectTypeEnum.YEAR);
    const tagYearsArray = tagYearsObject?.children;
    
    let proMaterialArray = proMaterials;
    let unsorted: ProMaterialInterface[] = [];

    function onlyUnique(value: any, index: any, self: string | any[]) {
      return self.indexOf(value) === index;
    }

    let yearArray: string[] = [];
    let proMaterialGroups: (ProMaterialInterface[] | undefined)[] = [];

    proMaterialArray?.forEach(proMaterial => {
      proMaterial.attributes?.tagIds?.forEach(tagId => {
        const found = tagYearsArray?.find(x => x.tag?.id == tagId);
        if (found) {
          yearArray.push(moment(found.tag?.name).format('YYYY.'));
        } else {
          yearArray.push('');
        }
      });
    });

    let unique = yearArray?.filter(onlyUnique);

    unique?.forEach(entry => {
      let sameYearProMaterials: ProMaterialInterface[] = [];
      proMaterialArray?.forEach(proMaterial => {
        proMaterial.attributes?.tagIds?.forEach(tagId => {
          const found = tagYearsArray?.find(x => x.tag?.id == tagId);
          if (found && entry == moment(found.tag?.name).format('YYYY.')) {
            sameYearProMaterials.push(proMaterial);
          }
        });
      });
      proMaterialGroups.push(sameYearProMaterials);
    });

    proMaterialArray?.forEach(proMaterial => {
      let foundOne = false;
      proMaterial.attributes?.tagIds?.forEach(tagId => {
        const found = tagYearsArray?.find(x => x.tag?.id == tagId);
        if (found) {
          foundOne = true;
        }
      });
      if (!foundOne) unsorted.push(proMaterial);
    });

    proMaterialGroups.push(unsorted);

    return proMaterialGroups.filter(x => x?.length as number > 0);
  };

  const genHeader = (proMaterial: ProMaterialInterface | undefined) => {
    const tagYearsObject = tags?.tagScreens?.find(x => x.selectType === SelectTypeEnum.YEAR);
    const tagYearsArray = tagYearsObject?.children;

    let headerString = i18n.translate('common.unsorted');

    proMaterial?.attributes?.tagIds?.forEach(tagId => {
      const found = tagYearsArray?.find(x => x.tag?.id == tagId);
      if (found) {
        headerString = moment(found.tag?.name).format('YYYY.');
      }
    });

    return (
      <span className="header">
        <Text className="extraText">
          {headerString}
        </Text>
      </span>
    );
  };

  const getDefaultActiveKeys = (proMaterials: ProMaterialInterface[]) => {
    const tagYearsObject = tags?.tagScreens?.find(x => x.selectType === SelectTypeEnum.YEAR);
    const tagYearsArray = tagYearsObject?.children;
    
    let proMaterialArray = proMaterials;

    function onlyUnique(value: any, index: any, self: string | any[]) {
      return self.indexOf(value) === index;
    }

    let yearArray: string[] = [];
    let defaultOpenArray: string[] = [];

    proMaterialArray?.forEach(proMaterial => {
      proMaterial.attributes?.tagIds?.forEach(tagId => {
        const found = tagYearsArray?.find(x => x.tag?.id == tagId);
        if (found) {
          yearArray.push(moment(found.tag?.name).format('YYYY.'));
        } else {
          yearArray.push('');
        }
      });
    });

    let unique = yearArray?.filter(onlyUnique);

    unique?.forEach((entry, index) => {
      defaultOpenArray.push('proMaterial_sorted' + index);
    });

    if (defaultOpenArray.length === 0) defaultOpenArray.push('proMaterial_sorted' + 0);
    if (defaultOpenArray.length > 0) defaultOpenArray.push('proMaterial_sorted' + defaultOpenArray.length);

    return defaultOpenArray;
  };

  const onPaginationChange: PaginationProps['onChange'] = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);
    if (esSearch) {
      esSearchFunction(false, { from: pageSize * (page - 1), size: pageSize }, keyword, filterValues);
    } else {
      dispatch(
        getAllProMaterialsAction(
          filterValues,
          undefined,
          'sort=-year',
          `page[offset]=${pageSize * (page - 1)}&page[limit]=${pageSize}`
        )
      );
    }
  };

  const keywordChanged = (value: string) => {
    setKeyword(value);
  };

  const exactMatchChanged = (exactMatch: boolean) => {
    setExactMatch(exactMatch);
  };

  const convertDataType = (proMaterials: ProMaterialEsResponseInterface['hits']): ProMaterialInterface[] => {
    return proMaterials.map((proMaterial) => {
      return {
        id: proMaterial.id,
        type: proMaterial.index,
        attributes: proMaterial.source,
      };
    });
  };

  return (
    <div className="proMaterials w100-h100">
      <div className="proMaterials__breadcrumbs">
        <Breadcrumb>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>{i18n.translate('breadcrumbs.eu-practice')}</span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>{i18n.translate('menu.professional-materials')}</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className="proMaterials__admin">
        <div className="proMaterials__title">{i18n.translate('proMaterials.title')}</div>
        <Link
          to={AdminRoutes.PRO_MATERIALS.fullPath + `/new`}
          key={AdminRoutes.PRO_MATERIALS.path + `/new`}
        >
          <Button
            className="button"
            type="primary"
            size="large"
            style={{ fontSize: 16, fontWeight: 700, borderRadius: 0 }}
          >
            {i18n.translate('proMaterials.addButton')}
          </Button>
        </Link>
      </div>
      {tags.tagScreens && tags.tagScreens.length ? (
        <FilterComponent
          aggregation={esData?.aggregation?.buckets}
          filterAccess
          keyword={keyword}
          filters={tags.tagScreens}
          onFilterChange={refetch}
          onFilterRemove={resetSearch}
          onKeywordChange={keywordChanged}
          onExactMatchChange={exactMatchChanged}
        />
      ) : null}
      <YearDividerComponent title={''} />
      {esSearch && (
        <>
          {esData?.hits?.length ? (
            <Collapse className='noPointer' collapsible={undefined} activeKey={getDefaultActiveKeys(convertDataType(esData?.hits as ProMaterialEsResponseInterface["hits"]) as ProMaterialInterface[])} ghost expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 270 : 90} />}>
            {sortedProMaterials(convertDataType(esData?.hits as ProMaterialEsResponseInterface["hits"]) as ProMaterialInterface[])?.length ? 
            [...sortedProMaterials(convertDataType(esData?.hits as ProMaterialEsResponseInterface["hits"]) as ProMaterialInterface[])]
              .map((group, index: number) => (
                <Panel className='noPointer' showArrow={false} forceRender key={'proMaterial_sorted' + index} header={genHeader(group?.length && group[0] ? group[0] : undefined)}>
                  {group?.length ? (
                    [...(group as ProMaterialInterface[])]
                      ?.map((proMaterial, i) => (
                        <ProMaterialCardComponent key={'euProMaterial' + i} proMaterial={proMaterial} notes={noteData} tags={tags.tagScreens} />
                      ))
                  ) : (
                    <div className="center">
                      <NoDataComponent />
                    </div>
                  )}
                </Panel>
              )) : null}
            </Collapse>
          ) : (
            <NoDataComponent />
          )}
        </>
      )}
      {!esSearch && (
        <>
          {proMaterials.promaterials?.data?.length ? (
            <Collapse className='noPointer' collapsible={undefined} activeKey={getDefaultActiveKeys(proMaterials.promaterials?.data)} ghost expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 270 : 90} />}>
            {sortedProMaterials(proMaterials.promaterials?.data)?.length ? 
            [...sortedProMaterials(proMaterials.promaterials?.data)]
              .map((group, index: number) => (
                <Panel className='noPointer' showArrow={false} forceRender key={'proMaterial_sorted' + index} header={genHeader(group?.length && group[0] ? group[0] : undefined)}>
                  {group?.length ? (
                    [...(group as ProMaterialInterface[])]
                      ?.map((proMaterial, i) => (
                        <ProMaterialCardComponent key={'euProMaterial' + i} proMaterial={proMaterial} notes={noteData} tags={tags.tagScreens} />
                      ))
                  ) : (
                    <div className="center">
                      <NoDataComponent />
                    </div>
                  )}
                </Panel>
              )) : null}
            </Collapse>
          ) : (
            <NoDataComponent />
          )}
        </>
      )}
      {esSearch && (
        <>
          {esData?.hits?.length ? (
            <Pagination
              style={{ float: 'right', paddingTop: 16, paddingBottom: 16 }}
              onChange={onPaginationChange}
              current={page}
              pageSize={pageSize}
              pageSizeOptions={['10', '20', '50', '100']}
              locale={{ items_per_page: `${i18n.t('pagination.perPage')}` }}
              total={esData?.totalHits}
              hideOnSinglePage
              responsive
              showTotal={(total) => `${i18n.t('pagination.total')}: ${total}`}
            />
          ) : null}
        </>
      )}
      {!esSearch && (
        <>
          {proMaterials.promaterials?.data?.length ? (
            <Pagination
              style={{ float: 'right', paddingTop: 16, paddingBottom: 16 }}
              onChange={onPaginationChange}
              current={page}
              pageSize={pageSize}
              pageSizeOptions={['10', '20', '50', '100']}
              locale={{ items_per_page: `${i18n.t('pagination.perPage')}` }}
              total={proMaterials?.promaterials?.meta?.totalResourceCount}
              hideOnSinglePage
              responsive
              showTotal={(total) => `${i18n.t('pagination.total')}: ${total}`}
            />
          ) : null}
        </>
      )}
    </div>
  );
}

export default ProMaterialsPageComponent;
